import { config, modules } from './config';
import log from '../../utilities/log';
import isDotNet from '../../utilities/isDotNet';

export const CONFIG = config;
export const MODULES = modules;

export const getToken = () => {
  const tokenElement = document.getElementsByName(CONFIG.tokenElement);

  if (tokenElement.length === 1) {
    return tokenElement[0].value;
  }
  return log(CONFIG.noTokenFound);
};

export const request = (endpoint, token, params, method = CONFIG.method) => new Promise((resolve, reject) => {
  const xhr = new XMLHttpRequest();
  const data = new FormData();
  if (params) {
    Object.keys(params).forEach((key) => {
      data.append(key, params[key]);
    });
  }
  data.append(CONFIG.tokenKey, token);
  xhr.open(method, endpoint);
  xhr.onload = () => {
    if (xhr.status >= 200 && xhr.status < 300) {
      resolve(xhr.response);
    } else {
      reject(!isDotNet() ? CONFIG.notOnDotNet : xhr.statusText);
    }
  };
  xhr.onerror = () => reject(xhr.statusText);
  xhr.send(data);
});
